/**
 * 该配置文件打包编译之后内容无法修改， 打包之后需要修改的配置统一放置在static/config/app-config.js
 */

const Local = window.location;
//const host = `${Local.protocol}//${ Local.port == '3000' ? Local.hostname +':8080' : Local.host }`;
const host = APPCONFIG.IP;
const geohost = APPCONFIG.DisIp;

const Sites = {
  Geoesbmengine: host + "/skygeoesbmengine",
  GWebframe: host + "/skywebframe",
  Map: host + '/map',
  serpool: host + "/serpool"
}
module.exports = {
  ServiceConfig: {
    httpproxy: Sites.GWebframe + "/biz/httpproxy/httpproxy.jsp"
  },
  SgsConfig: {
    GetServiceNodes: Sites.Geoesbmengine + "/services/catalog/resource/service",
    GetCatalogNodes: Sites.Geoesbmengine + "/services/catalog/gategoty/view.json",
    GetResourceNodes: Sites.Geoesbmengine + "/services/catalog/resource/view.json",
    SearchResource: Sites.Geoesbmengine + "/services/resource/data/full/pri",
    SearchFullResource: Sites.Geoesbmengine + "/services/resource/data/full",
    GetRootTheme: Sites.Geoesbmengine + "/services/servicemanager/datacatalog/root.json",
    GetChildTheme: Sites.Geoesbmengine + "/services/servicemanager/datacatalog/tree",
    GetServiceDate: Sites.Geoesbmengine + "/services/resource/data/serinfo",
    GetCatalogFormt: Sites.Geoesbmengine + "/services/servicemanager/catalogformt/all.json",
    StyleLayer: Sites.Map + "/services/stylelayer", //地图定制增加/更新接口
    getStyleLayer: Sites.Map + "/services/stylelayer/getByServiceId", //查询风格图层
    StyleMap: Sites.Map + "/services/stylemap",
    getDatasetsByDataSourceId: Sites.serpool + "/services/tree/datasetinfo.json",
    getDatasetInfoByDatasetName: Sites.serpool + "/services/tree",
    GetSerPoolEntityTreeRoot: Sites.serpool + "/services/tree/root.json",
    getSerPoolChildTheme: Sites.serpool + "/services/tree/child/datasource.json",
    getEntityServiceList: Sites.serpool + "/services/service/servicelist.json",
    getAllFields: Sites.Geoesbmengine + "/services/datameta/getAllfields",//获取属性服务所有字段
    fiddlerBehavior:Sites.Geoesbmengine+"/services/log/behaviorStat/fiddlerBehavior.json", //行为监控
    getInterfaceOperate:Sites.Geoesbmengine+"/services/servicetype/{0}/interfacetype/{1}/requestoperator.json"//获取服务操作信息
  },
  Geoesbmengine: {
    location: host + '/skygeoesbmengine',
  },
  Map: {
    location: host + '/map'
  },
  DFC: {
    location: host + '/dfc',
    transformUrl: host + '/dfc/services/prjCoordSysTransform/transformpoints/inverse.json',
    GetDataByDatasetid: host + '/dfc/services/sgssfs/',
  },
  GeoEntity: {
    location: geohost + '/geoentity'
  },
  Usercenter: {
    location: host + '/usercenter'
  },
  Cas: {
    location: host + '/skycas'
  },
  Nav: {
    location: host + '/nav'
  },
  Editmanager: {
    location: host + '/editmanager'
  },
  Webframe: {
    location: Sites.GWebframe
  },
  Quota: {
    location: APPCONFIG.QuotaHost + '/quotamanager'
  },
  Serpool: {
    location: host + '/serpool'
  },
  Mule: {
    location: APPCONFIG.MuleHost + '/geoesb/proxy/'
  },
  Condition:{
    greater : "大于",
    greater_eq : "大于等于",
    less : "小于",
    less_eq : "小于等于",
    eq : "等于",
    like : "模糊",
    equals : "等于",
    include : "包含",
    notinclude : "不包含"
  },
  dataThemesConfig: [{
				name: "矢量数据服务",
				theme: "00100010005",
				imgUrl: "/static/img/slsj.png",
			},
			{
				name: "智能地图服务",
				theme: "00100010003",
				imgUrl: "/static/img/zndt.png",
			},
			{
				name: "影像数据服务",
				theme: "00100010006",
				imgUrl: "/static/img/yxsj.png",
			},
			{
				name: "时态数据服务",
				theme: "0010007",
				imgUrl: "/static/img/stsj.png",
			},
			{
				name: "OGC",
				theme: "0010001",
				imgUrl: "/static/img/OGC.png",
			},
      ],
      jichuGNConfig: [{
				name: "专题应用",
				url: "https://10.210.96.137/AdvancedPortal/viewer/typical_application.html",
				imgUrl: "../static/img/ztyy.png",
				subtitle: "满足一体化云平台",
				backUrl: "../static/img/ztyy_back.png",
			},
			{
				name: "地理编码",
				url: "https://119.163.126.19:8085/dfc/geocoding/dmanage/dict/#0",
				imgUrl: "/static/img/dlbm.png",
				subtitle: "满足一体化云平台",
				backUrl: "/static/img/dlbm_back.png",
			},
			{
				name: "快速定制",
				url: "https://10.210.96.137/AdvancedPortal/viewer/builder.html",
				imgUrl: "/static/img/ksdz.png",
				subtitle: "满足一体化云平台",
				backUrl: "/static/img/ksdz_back.png",
			},
			{
				name: "在线制图",
				url: "https://10.210.96.137/AdvancedPortal/viewer/webmap.html",
				imgUrl: "/static/img/zxzt.png",
				subtitle: "满足一体化云平台",
				backUrl: "/static/img/zxzt_back.png",
			},
		]

}



// WEBPACK FOOTER //
// ./src/config/app-config.js